const t = "_playButtonWrapper_lwex2_1", o = "_playButtonBackground_lwex2_15", n = "_icon_lwex2_29", a = {
  playButtonWrapper: t,
  playButtonBackground: o,
  icon: n
};
export {
  a as default,
  n as icon,
  o as playButtonBackground,
  t as playButtonWrapper
};
